// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page_3CAtg","content":"Page_content_1OD76","sidebar":"Page_sidebar_3RqTr","pageCollapsed":"Page_pageCollapsed_3WgAQ","main":"Page_main_1fiaS"};